import React from 'react'
import api from '../../../modules/api'
import auth from '../../../modules/auth'

class AccountConfirmation extends React.Component {
  componentDidMount() {
    let uuid = this.props.match.params.uuid
    let urlParams = new URLSearchParams(window.location.search)
    let expire_at = urlParams.get('expire_at')
    // メールリンクでuuidがブランクでフロントログイン済の場合は/reportsに遷移させる
    if (!uuid) {
      if (auth.loggedIn()) {
        this.props.history.push('/reports')
      }
      if (expire_at){
        window.location.href="/customer/login"
      }
      return
    }
    let data = { uuid: uuid }
    if (expire_at){
      data["expire_at"] = expire_at
    }
    let self = this
    api.login(data)
      .then(response => {
        if(response.data.status === "failed") {
          if(response.data.error.code === "invalid_aflac_uuid"){
            window.location.href="/customer/login"
          } else {
            if(auth.loggedIn()) {
              self.props.history.push('/signup')
            } else {
              self.props.history.push('/')
            }
          }
        } else {
          if(response.data.is_aflac === 'true') {
            sessionStorage.is_aflac = 'true'
          }
          auth.login(response.data, Boolean(localStorage.info))
          this.props.updateSignUpSettings({
            accountConfirmation: true
          }, true)
          self.props.history.push('/signup')
        }
      })
      .catch(error => {
        auth.logout()
        self.props.history.push('/')
      })
  }

  render() {
    return (
      <div className="account-confirmation"/>
    )
  }
}

export default AccountConfirmation



// WEBPACK FOOTER //
// ./src/routes/accountConfirmation/components/AccountConfirmation.js